<template>
  <crud-table
    :create-route="{
      name: 'leagues.data-fields.create',
      params: { leagueId: leagueId },
    }"
    :columns="fields"
    vuex-prefix="league_data"
    create-role="Developer"
    :fetch-address="fetchAddress"
  >
    <template #cell(kind)="data">
      <span v-if="data.item.kind === '0'">Int</span>
      <span v-if="data.item.kind === '1'">Double</span>
      <span v-if="data.item.kind === '2'">String</span>
      <span v-if="data.item.kind === '3'">Boolean</span>
    </template>
    <template #cell(olaviat)="data">
      <span v-if="data.item.olaviat == -1">تعیین نشده</span>
    </template>
    <template #cell(actions)="data">
      <table-action-buttons
        fa-title="فیلد"
        route="league-data"
        :record-id="data.item.id"
        :delete-title="data.item.name"
        :delete-route="`leagues/${leagueId}/data-fields/${data.item.id}`"
        :edit-route="{
          name: 'leagues.data-fields.edit',
          params: { leagueId: leagueId, id: data.item.id },
        }"
        hidden-show-button
        :hidden-edit-button="readOnlyDataFields.includes(data.item.name)"
        :hidden-delete-button="readOnlyDataFields.includes(data.item.name)"
        @deleted="data.itemDeleted(data.itemDeleted(data.item))"
        permission="application_data_field"
        role="Developer"
      >
      </table-action-buttons>
    </template>
  </crud-table>
</template>

<script>
export default {
  props: {
    leagueId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    fetchAddress() {
      return `leagues/${this.leagueId}/data-fields`
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'name',
          sortable: true,
          label: 'نام فیلد',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'olaviat',
          sortable: true,
          label: 'اولویت',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'kind',
          sortable: true,
          label: 'نوع فیلد',
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
          thStyle: { width: '180px' },
          filter: {
            component: 'SelectFilter',
            operator: '$in',
            value: [],
            items: [
              {
                text: 'Int',
                value: 0,
              },
              {
                text: 'Double',
                value: 1,
              },
              {
                text: 'String',
                value: 2,
              },
              {
                text: 'Boolean',
                value: 3,
              },
            ],
          },
        },
      ],
      readOnlyDataFields: [
        'id',
        'playerId',
        'appId',
        'score',
        'isShow',
        'scoreChangeDate',
        'lId',
        'myCount',
      ],
    }
  },
}
</script>
